import SubNavBarDesktop from './SubNavBarDesktop';
import SubNavBarDesktopBranched from './SubNavBarDesktop.updated_subnav';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';

export default withFeatureBranch({
  updated_subnav: SubNavBarDesktopBranched,
})(SubNavBarDesktop);
